import { connect } from 'react-redux';

import ProgressLine from './progressLine';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(ProgressLine);
